/*******************************************************************************
Open Side Navigation
Opens the offscreen navigation menu on the right side of the page.
*******************************************************************************/

//import activateStickyHeaders from './sticky-headers/activate';
import addSearchFeature from './search/add-to-nav';
import clearSectionSearch from './search/clear';

// Opens the side navigation menu
export default function openSideNav(e) {

    // The side nav container
    const $sideNav = $('.side-nav');

    // Exit out if the side nav is already open
    if ($sideNav.hasClass('is-open')) { return; }

    // Get the type of menu to display (Main or Section)
    const menu = $(e.currentTarget).data('menu');

    // Special classes for each menu type to control which items display
    const menus = {
        Main   : 'viewing-main',
        Section: 'viewing-section',
    };

    // Set the classes on the side nav container so it opens and displays the correct menu
    $sideNav.removeClass('viewing-main viewing-section').addClass(`is-open ${menus[menu]}`);

    // Add a class to the site wrapper so it fades into the background when the side nav menu is open
    $('.site-wrapper').addClass('side-nav-is-open');

    // Set overflow:hidden on the body of the page to stop it from scrolling when scrolling the side nav (not foolproof)
    $('body').addClass('hide-overflow');

    // Conditionally turn on search feature
    // Only certain sports (with lots of links) will need the search feature so
    // this adds it to only those sports.
    addSearchFeature();

    // Clear the section search
    clearSectionSearch();

    // Activates sticky headers in the side navigation panel
    //activateStickyHeaders('.side-nav__sub-section', '.side-nav__middle');
}
